import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { getFilterValues } from '../sbSharedRefineMenuHelpers';
import { LEAD_TIME_BUCKET_DEFAULT_URLLABEL } from '../sbSharedRefineMenuConstants';

// components
import { SbSharedRefineMenuRadioSelect } from './../SbSharedRefineMenuRadioSelect/SbSharedRefineMenuRadioSelect';
import { SbSharedRefineMenuExpandableItemList } from '../SbSharedRefineMenuExpandableItemList/SbSharedRefineMenuExpandableItemList';

export const SbSharedRefineMenuFilterAvailabilityComponent = props => {
    const { values, searchBrowse, filterName } = props;
    const { appliedFilters, displayUriRef } = searchBrowse;

    const valuesToShowCopy = [...values];
    const appliedFilterValues = getFilterValues(appliedFilters, filterName);
    const defaultIndex = values.findIndex(
        value => value.urlLabel === LEAD_TIME_BUCKET_DEFAULT_URLLABEL
    );
    const defaultValue = defaultIndex > -1 ? valuesToShowCopy.splice(defaultIndex, 1)[0] : {};

    return (
        <SbSharedRefineMenuExpandableItemList
            filterName={filterName}
            availableFilterValues={valuesToShowCopy}
        >
            {({ valuesToShow }) => (
                <SbSharedRefineMenuRadioSelect
                    canBeDismissed
                    filterName={filterName}
                    valuesToShow={valuesToShow}
                    displayUriRef={displayUriRef}
                    totalCount={defaultValue.count}
                    appliedFilterValues={appliedFilterValues}
                />
            )}
        </SbSharedRefineMenuExpandableItemList>
    );
};

SbSharedRefineMenuFilterAvailabilityComponent.propTypes = {
    values: PropTypes.array.isRequired,
    filterName: PropTypes.string.isRequired,
    searchBrowse: PropTypes.object.isRequired,
};

export const SbSharedRefineMenuFilterAvailability = createFragmentContainer(
    SbSharedRefineMenuFilterAvailabilityComponent,
    {
        searchBrowse: graphql`
            fragment SbSharedRefineMenuFilterAvailability_searchBrowse on SearchBrowseQueryConnection {
                displayUriRef
                appliedFilters {
                    name
                    values {
                        urlLabel
                        count
                    }
                }
            }
        `,
    }
);
